import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const customRoutes = [
  { method: "GET", path: "/by-payer", handlerName: "getByPayer" },
  { method: "GET", path: "/details", handlerName: "getWithDetails" },
];

const api = new CommonAPIService(router);
const baseService = createCrudService("offices", customRoutes, router);

export const officesService = {
  ...baseService,
  listPaginated: (params) => api.getCall("/api/offices/paginated", params),
  generateUsor95Pdfs: (officeId, serviceCodeId, month, year, notificationEmail) =>
    api.postCall(`/api/offices/${officeId}/generate-usor95`, { serviceCodeId, month, year, notificationEmail }),
  generateUsor148Pdfs: (officeId, serviceCodeId, month, year, notificationEmail) =>
    api.postCall(`/api/offices/${officeId}/generate-usor148`, { serviceCodeId, month, year, notificationEmail }),
  generateUsor96Pdfs: (officeId, serviceCodeId, month, year, notificationEmail) =>
    api.postCall(`/api/offices/${officeId}/generate-usor96`, { serviceCodeId, month, year, notificationEmail }),
  regenerateUsorForm: (authorizationId, month, year, formType) =>
    api.postCall("/api/offices/regenerate-usor-form", { authorizationId, month, year, formType }),
  regenerateInvoice: (authorizationId, month, year) =>
    api.postCall("/api/offices/regenerate-invoice", { authorizationId, month, year }),
};
